import { oc } from '@orpc/contract';
import { archiveTemplateInputSchema, templateDetailSchema } from '../schemas/templates.schemas.js';
/** Hides the template from selection. Existing estimates and vehicles keep their version untouched. */
export const archiveTemplateContract = oc
    .route({
    method: 'POST',
    path: '/templates/{templateId}/archive',
    tags: ['Templates'],
    summary: 'Archive the template',
})
    .input(archiveTemplateInputSchema)
    .output(templateDetailSchema);
//# sourceMappingURL=archive-template.contract.js.map